import React from 'react';

interface ApplicationContext {
  theme: string;
}

export default React.createContext<ApplicationContext>({
  theme: 'light'
});
